import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@omni/components/components/Product/ProductTile/productTile.adapter"
    ).then((module) => ({
        default: module.ProductTileAdapter
    }))
);
